const MONTHS = { A: '01', B: '02', C: '03', D: '04', E: '05', H: '06', L: '07', M: '08', P: '09', R: '10', S: '11', T: '12' };


const ageCf = (cf) => {
  let [anno, giorno] = [cf.substring(6, 8), cf.substring(9, 11)];
  if (giorno > 40) {
    giorno -= 40;
    giorno = "0" + giorno;
  }
  return (anno < 20 ? "20" : "19") + anno + "-" + MONTHS[cf.charAt(8)] + "-" + giorno;
}

function getAge(dateString) {
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

function isUser75OrOlder(birthdateString: string) {
  if (!birthdateString) return;
  const [day, month, year] = birthdateString.split('/');
  const birthdate = new Date(`${month}/${day}/${year}`);
  const currentDate = new Date();
  // Calculate the user's age
  const age = currentDate.getFullYear() - birthdate.getFullYear();
  // Check if the birthday has occurred for the current year
  const hasBirthdayOccurred =
    currentDate.getMonth() > birthdate.getMonth() ||
    (currentDate.getMonth() === birthdate.getMonth() &&
      currentDate.getDate() >= birthdate.getDate());

  // If the birthday has not occurred, decrement the age
  const adjustedAge = hasBirthdayOccurred ? age : age - 1;

  // Verifica se il cambio di mese è avvenuto rispetto al compleanno
  const isMonthChange = currentDate.getMonth() !== birthdate.getMonth();

  // Verifica se l'utente ha 75 anni o più ed è avvenuto il cambio di mese
  const is75OrOlder = adjustedAge >= 75 && isMonthChange;

  return is75OrOlder;
}


function isPast2024() {
  var currentDate = new Date();

  // Define the target date (01/01/2024)
  var targetDate = new Date(2024, 0, 1); // Note: Months are zero-based, so January is 0

  // Compare the current date with the target date
  return currentDate > targetDate;
}


function checkUserAgeByCf(cf: string) {
  if (!cf) return;
  let monthTable = {
    "A": "01",
    "B": "02",
    "C": "03",
    "D": "04",
    "E": "05",
    "H": "06",
    "L": "07",
    "M": "08",
    "P": "09",
    "R": "10",
    "S": "11",
    "T": "12"
  };

  return cf.replace(/^(?:\w{6})(\d{2})(\w)(\d{2}).+$/, function (data, aa, mm, gg) {

    let year = parseInt(aa, 10);
    var secolo = (year < 9) ? '20' : '19';
    let yearFormatted = [secolo, aa].join('');

    var giorno = parseInt(gg, 10);
    var sesso = (giorno > 31) ? 'F' : 'M';
    if (sesso === 'F') giorno -= 40;

    var mese = mm.toUpperCase();
    mese = monthTable[mese];

    return [giorno, mese, yearFormatted].join("/");
  });
}

export { ageCf, getAge, isUser75OrOlder, checkUserAgeByCf, isPast2024 }



// WEBPACK FOOTER //
// ./src/app/utils/cf.ts